import React, { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import {
  Button,
  Nav,
  Spinner,
  Tab,
} from "react-bootstrap";
import styles from "../wallet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  unclaimedListApi,
  getUserProfile,
  bitanicaHistoryApi,
} from "../../../../lib/store/actions";
import moment from "moment";
import LoaderCstm from "../../../../components/Loader";
import { showToast, wait } from "../../../../helper/common";
import InfiniteScroll from "react-infinite-scroll-component";
import LinkAccountPop from "../../../../components/Modals/LinkAccountPop";
import { useGameContext } from "../../../../context/GameContext";
import CountdownTimer from "./timer";
import { useWindow } from "../../../../hooks/useWindow";
import diamond1 from '../../../../assets/images/diamond1.png';
import wavesvg from '../../../../assets/images/waveSvg.svg';
import ClaimChoicePop from '../../../../components/Modals/ClaimChoicePop';
import usePageVisibility from "../../../../hooks/useVisibilityDetection";

const wave = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="379"
    height="48"
    viewBox="0 0 379 48"
    fill="none"
  >
    <path
      opacity="0.3"
      d="M68.9091 24.4145C54.3198 23.0043 47.9672 18.2875 34.4545 17.8462C24.6722 17.5266 15.962 19.63 8.30353 22.3392C3.20356 24.1434 0 29.1161 0 34.5258C0 41.9674 6.03259 48 13.4742 48H368.419C374.263 48 379 43.2629 379 37.4194C379 25.7505 360.527 23.149 349.902 27.9735C348.16 28.7643 346.373 29.1992 344.545 29.1992C328.449 29.1992 324.519 4.58455 310.091 1.19243C295.663 -2.19968 288.988 13.7199 275.636 14.934C262.285 16.1481 251.68 10.6748 241.182 8.9552C230.684 7.23563 219.217 4.48081 206.727 7.83154C194.238 11.1823 187.723 33.2593 172.273 36.9102C156.822 40.561 151.6 29.1992 137.818 27.4196C124.036 25.6401 117.845 26.4078 103.364 25.8247C88.882 25.2416 83.4984 25.8247 68.9091 24.4145Z"
      fill="url(#paint0_linear_1_725)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_725"
        x1="-5.45682"
        y1="14.5714"
        x2="229.179"
        y2="216.458"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#43BFFF" stop-opacity="0" />
        <stop offset="0.54" stop-color="#00EFC0" />
        <stop offset="0.962409" stop-color="#00EFC0" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
const starBg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={371}
    height={107}
    viewBox="0 0 371 107"
    fill="none"
    className="w-100 h-100"
  >
    <mask
      id="mask0_8_12541"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={371}
      height={107}
    >
      <rect width={371} height={107} rx={15} fill="#13131B" />
    </mask>
    <g mask="url(#mask0_8_12541)">
      <path
        d="M259.275 88.0666L254.107 82.7926L261.343 80.0284L253.499 79.3194L251.76 72.2957L248.677 79.5149L241.341 76.8505L247.193 82.6418L243.039 87.1029L249.041 85.7574L251.107 92.0951L252.475 85.9373L259.275 88.0666Z"
        fill="url(#paint0_linear_8_12541)"
      />
      <path
        d="M236.153 30.3345C235.721 32.4141 232.036 33.0035 231.355 30.2962C230.612 27.3349 235.031 26.4772 236.018 29.036C236.205 29.5151 236.234 29.9512 236.153 30.3345Z"
        fill="url(#paint1_linear_8_12541)"
      />
      <path
        d="M137.923 30.2962C139.098 32.0643 136.922 35.0975 134.521 33.6743C131.894 32.117 134.391 28.3747 136.907 29.4768C137.377 29.6828 137.708 29.9655 137.928 30.2962H137.923Z"
        fill="white"
      />
      <path
        d="M341.675 90.2934L337.596 89.8046L339.763 86L336.12 88.4821L332.919 86L334.102 90.2934L330 91.7309L334.553 92.2053L334.313 95.6553L336.441 92.9192L339.547 94.9845L337.989 91.774L341.675 90.2934Z"
        fill="url(#paint2_linear_8_12541)"
      />
      <path
        d="M97.8811 92.8135C97.4498 94.8931 93.7595 95.4825 93.0837 92.7752C92.3409 89.8139 96.7596 88.9562 97.7469 91.515C97.9291 91.9941 97.9626 92.4302 97.8811 92.8135Z"
        fill="url(#paint3_linear_8_12541)"
      />
      <path
        d="M11.8811 66.8135C11.4498 68.8931 7.75947 69.4825 7.08371 66.7752C6.34086 63.8139 10.7597 62.9562 11.7469 65.515C11.9291 65.9941 11.9626 66.4302 11.8811 66.8135Z"
        fill="url(#paint4_linear_8_12541)"
      />
      <path
        d="M354.881 16.8135C354.45 18.8931 350.759 19.4825 350.084 16.7752C349.341 13.8139 353.76 12.9562 354.747 15.515C354.929 15.9941 354.963 16.4302 354.881 16.8135Z"
        fill="url(#paint5_linear_8_12541)"
      />
      <path
        d="M133.68 65.2934L129.601 64.8046L131.767 61L128.125 63.4869L124.919 61L126.107 65.2934L122 66.7309L126.553 67.2053L126.313 70.6601L128.446 67.924L131.552 69.9845L129.994 66.7788L133.68 65.2934Z"
        fill="url(#paint6_linear_8_12541)"
      />
      <path
        d="M182.881 7.81559C182.45 9.89519 178.759 10.4846 178.084 7.77725C177.341 4.81597 181.76 3.95346 182.747 6.51703C182.929 6.9962 182.963 7.43225 182.881 7.82038V7.81559Z"
        fill="#0FB463"
      />
      <path
        d="M27 12.6642L20.3681 11.9074L23.8873 6L17.9616 9.85919L12.75 6L14.6792 12.6642L8 14.9006L15.4091 15.6348L15.0224 21L18.4824 16.7492L23.5361 19.9533L21.0033 14.9721L27 12.6642Z"
        fill="url(#paint7_linear_8_12541)"
      />
      <path
        d="M275.429 -2.51465L261.665 -4.163L268.973 -17L256.675 -8.6145L245.858 -17L249.865 -2.51465L236 2.34894L251.38 3.94457L250.57 15.6076L257.759 6.36439L268.245 13.3363L262.987 2.49748L275.429 -2.51465Z"
        fill="url(#paint8_linear_8_12541)"
      />
      <path
        d="M180.429 101.485L166.665 99.837L173.973 87L161.675 95.3855L150.858 87L154.865 101.485L141 106.349L156.38 107.945L155.57 119.608L162.759 110.364L173.245 117.336L167.987 106.497L180.429 101.485Z"
        fill="url(#paint9_linear_8_12541)"
      />
      <path
        d="M42.807 83.0214C42.5099 84.4589 39.9602 84.8614 39.4953 82.9927C38.9825 80.9466 42.0306 80.3524 42.716 82.1206C42.8454 82.4512 42.8645 82.7531 42.8118 83.0166L42.807 83.0214Z"
        fill="url(#paint10_linear_8_12541)"
      />
      <path
        d="M308.066 20.7775C308.924 20.0387 309.039 18.7731 308.986 17.7329C308.953 16.992 308.755 16.2311 308.659 15.499C308.386 13.3091 310.455 11.5706 312.427 12.6387C314.746 13.893 317.065 18.125 320.291 17.1546C321.434 16.8108 321.87 15.4834 322.3 14.5182C323.025 12.9037 323.848 11.3648 325.305 10.2859C327.27 8.83392 329.975 10.7879 331.587 11.8742C332.271 12.3342 332.872 11.2026 332.194 10.7459C329.163 8.70493 326.121 7.49298 323.266 10.3788C322.165 11.4909 321.026 16.1878 319.126 15.8586C316.868 15.4719 315.325 13.2536 313.639 11.924C311.48 10.2211 309.502 10.9314 307.932 12.9651C307.256 13.8442 307.32 15.0561 307.451 16.0879C307.545 16.8352 307.694 17.5613 307.73 18.3159C307.944 22.8359 301.945 20.3918 300.387 18.6733C299.834 18.0641 298.965 19.0012 299.514 19.6118C301.872 22.2105 305.218 23.2359 308.061 20.7789L308.066 20.7775Z"
        fill="url(#paint11_linear_8_12541)"
      />
      <path
        d="M113.119 -15.9875C114.176 -16.3778 116.161 -7.5032 116.161 -7.5032C116.161 -7.5032 112.063 -15.5972 113.119 -15.9875ZM112.575 -4.4469C112.575 -4.4469 105.436 -9.94953 104.873 -8.96204C104.31 -7.97242 112.575 -4.4469 112.575 -4.4469ZM111.762 0.230338C111.762 0.230338 102.808 0.673962 103.003 1.79795C103.199 2.92194 111.762 0.230338 111.762 0.230338ZM114.102 4.34665C114.102 4.34665 107.524 10.5296 108.385 11.2633C109.246 11.997 114.102 4.34665 114.102 4.34665ZM118.501 5.96971C118.501 5.96971 117.375 15 118.501 15C119.627 15 118.501 5.96971 118.501 5.96971ZM122.898 4.34452C122.898 4.34452 127.752 11.9949 128.615 11.2612C129.476 10.5275 122.898 4.34452 122.898 4.34452ZM125.238 0.230338C125.238 0.230338 133.801 2.92194 133.997 1.79795C134.192 0.673962 125.238 0.230338 125.238 0.230338ZM124.427 -4.44903C124.427 -4.44903 132.692 -7.97455 132.129 -8.96417C131.567 -9.95379 124.427 -4.44903 124.427 -4.44903ZM120.841 -7.5032C120.841 -7.5032 124.941 -15.5972 123.883 -15.9875C122.826 -16.3778 120.841 -7.50107 120.841 -7.50107V-7.5032ZM114.739 -4.64312C114.739 -4.64312 110.712 -11.2932 109.851 -10.5574C108.99 -9.82369 114.739 -4.64312 114.739 -4.64312ZM112.739 -1.12399C112.739 -1.12399 105.444 -3.58951 105.249 -2.46339C105.053 -1.3394 112.739 -1.12399 112.739 -1.12399ZM113.432 2.87715C113.432 2.87715 106.282 5.75003 106.845 6.73965C107.408 7.72927 113.432 2.87715 113.432 2.87715ZM116.499 5.4877C116.499 5.4877 112.84 12.3532 113.897 12.7435C114.953 13.1338 116.499 5.4877 116.499 5.4877ZM120.501 5.4877C120.501 5.4877 122.045 13.1338 123.101 12.7435C124.158 12.3532 120.501 5.4877 120.501 5.4877ZM123.568 2.87502C123.568 2.87502 129.592 7.72501 130.155 6.73539C130.718 5.74577 123.568 2.87502 123.568 2.87502ZM124.263 -1.12612C124.263 -1.12612 131.949 -1.34367 131.753 -2.46766C131.558 -3.59164 124.263 -1.12612 124.263 -1.12612ZM122.261 -4.64525C122.261 -4.64525 128.012 -9.82796 127.151 -10.5616C126.29 -11.2953 122.261 -4.64525 122.261 -4.64525ZM118.501 -6.0337C118.501 -6.0337 119.627 -13.7566 118.501 -13.7566C117.375 -13.7566 118.501 -6.0337 118.501 -6.0337ZM116.268 -1.98778C116.268 -1.98778 113.928 -4.67724 113.367 -3.68975C112.804 -2.70013 116.268 -1.98778 116.268 -1.98778ZM115.961 -0.223948C115.961 -0.223948 112.466 -0.757149 112.662 0.366838C112.857 1.49083 115.961 -0.223948 115.961 -0.223948ZM116.844 1.3266C116.844 1.3266 113.827 3.1992 114.689 3.93288C115.55 4.66657 116.844 1.3266 116.844 1.3266ZM118.501 1.93871C118.501 1.93871 117.375 5.34053 118.501 5.34053C119.627 5.34053 118.501 1.93871 118.501 1.93871ZM120.156 1.3266C120.156 1.3266 121.448 4.66657 122.309 3.93288C123.171 3.1992 120.156 1.3266 120.156 1.3266ZM121.039 -0.223948C121.039 -0.223948 124.143 1.49083 124.338 0.366838C124.534 -0.757149 121.039 -0.223948 121.039 -0.223948ZM120.734 -1.98778C120.734 -1.98778 124.2 -2.70013 123.637 -3.68975C123.074 -4.67937 120.734 -1.98778 120.734 -1.98778ZM119.381 -3.13736C119.381 -3.13736 121.585 -5.94413 120.528 -6.33443C119.472 -6.72473 119.381 -3.13736 119.381 -3.13736ZM117.619 -3.13736C117.619 -3.13736 117.531 -6.72473 116.472 -6.33443C115.415 -5.94413 117.619 -3.13736 117.619 -3.13736Z"
        fill="url(#paint12_linear_8_12541)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_8_12541"
        x1="240.929"
        y1="87.7179"
        x2="258.391"
        y2="77.5846"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42E0FF" />
        <stop offset={1} stopColor="#4212FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8_12541"
        x1="232.678"
        y1="32.4716"
        x2="234.451"
        y2="27.9528"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42E0FF" />
        <stop offset={1} stopColor="#4212FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8_12541"
        x1="336.475"
        y1="95.4301"
        x2="335.066"
        y2="85.6885"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7B00" />
        <stop offset="0.99" stopColor="#FFC123" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8_12541"
        x1="95.7915"
        y1="94.5673"
        x2="95.1304"
        y2="90.0103"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE59BC" />
        <stop offset="0.99" stopColor="#FE115D" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8_12541"
        x1="9.79155"
        y1="68.5625"
        x2="9.13041"
        y2="64.0055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE59BC" />
        <stop offset="0.99" stopColor="#FE115D" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_8_12541"
        x1="352.792"
        y1="18.5625"
        x2="352.13"
        y2="14.0055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE59BC" />
        <stop offset="0.99" stopColor="#FE115D" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_8_12541"
        x1="128.48"
        y1="70.4301"
        x2="127.066"
        y2="60.6933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7B00" />
        <stop offset="0.99" stopColor="#FFC123" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_8_12541"
        x1="13.8862"
        y1="22.5889"
        x2="20.1407"
        y2="5.85415"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42E0FF" />
        <stop offset={1} stopColor="#4212FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_8_12541"
        x1="257.874"
        y1="14.8361"
        x2="253.111"
        y2="-18.0544"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7B00" />
        <stop offset="0.99" stopColor="#FFC123" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_8_12541"
        x1="162.874"
        y1="118.836"
        x2="158.111"
        y2="85.9456"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7B00" />
        <stop offset="0.99" stopColor="#FFC123" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_8_12541"
        x1="41.3645"
        y1="84.2337"
        x2="40.9093"
        y2="81.0855"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7B00" />
        <stop offset="0.99" stopColor="#FFC123" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_8_12541"
        x1="300.26"
        y1="21.2789"
        x2="330.626"
        y2="7.13055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7B00" />
        <stop offset="0.99" stopColor="#FFC123" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_8_12541"
        x1="111.765"
        y1="16.2989"
        x2="123.723"
        y2="-13.7651"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42E0FF" />
        <stop offset={1} stopColor="#4212FF" />
      </linearGradient>
    </defs>
  </svg>
);
const lock = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.81832 8.45616C5.07671 8.45616 4.47563 7.88833 4.47563 7.18774C4.47563 6.63597 4.85069 6.17173 5.37076 5.99711V3.80527C5.37076 3.57188 5.57082 3.38247 5.81832 3.38247C6.06582 3.38247 6.26588 3.57188 6.26588 3.80527V5.99711C6.78595 6.17173 7.16101 6.63597 7.16101 7.18774C7.16101 7.88833 6.55993 8.45616 5.81832 8.45616ZM6.2614 1.71237L6.26588 0.845616H8.05614C8.30364 0.845616 8.5037 0.656621 8.5037 0.422808C8.5037 0.188995 8.30364 0 8.05614 0H3.58051C3.333 0 3.13294 0.188995 3.13294 0.422808C3.13294 0.656621 3.333 0.845616 3.58051 0.845616H5.37076V1.69123L5.37524 1.71237C2.36985 1.92715 0 4.29319 0 7.18774C0 10.2235 2.60482 12.6842 5.81832 12.6842C9.03182 12.6842 11.6366 10.2235 11.6366 7.18774C11.6366 4.29319 9.26679 1.92715 6.2614 1.71237Z"
      fill="#54B3F5"
    />
  </svg>
);

const CryptoHistory = () => {
  const buttonRef = useRef(null);
  const optionsRef = useRef(null);
  const location = useLocation();

  const { setGameEnergyLeft, setBtncBalance } = useGameContext();
  const dispatch = useDispatch();
  const {
    user,
    unclaimedCoinsList,
    totalUnclaimedCoins,
    unclaimLoading,
    isBitanicaLinked,
    loadingBitanicLink,
    bitanicaHistory,
    bitanicaHistoryCount,
    bitanicaHistoryLoading,
  } = useSelector(({ Auth, Game }) => ({
    user: Auth.user,
    unclaimedCoinsList: Game.unclaimedCoinsList,
    totalUnclaimedCoins: Game.totalUnclaimedCoins,
    unclaimLoading: Game.unclaimLoading,
    binaticaLoading: Game.binaticaLoading,
    claimLoading: Game.claimLoading,
    isBitanicaLinked: Auth.isBitanicaLinked,
    loadingBitanicLink: Auth.loadingBitanicLink,
    bitanicaHistoryLoading: Game.bitanicaHistoryLoading,
    bitanicaHistory: Game.bitanicaHistory,
    bitanicaHistoryCount: Game.bitanicaHistoryCount,
  }));

  const [linkAccount, setLinkAccount] = useState();
  const [rowData, setRowData] = useState(null);
  const [scrollStopOn, setScrollStopOn] = useState(false);
  const [clickChoicePopup, setClickChoicePopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "",
  });

  const [bitanicaFilter, setBitanicaFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    // status: "claimed",
    // withdrawalPlatform: "bitanica"
  });

  useEffect(() => {
    console.log('Screen is in focus, running the code...');
    dispatch(unclaimedListApi({ ...filter }));
    dispatch(bitanicaHistoryApi({ ...bitanicaFilter }));
  }, [location, dispatch, filter, bitanicaFilter]);

  const handlePopupClose = async () => {
    console.log("handle popup close called --->")
    dispatch(unclaimedListApi({ ...filter }));
    dispatch(bitanicaHistoryApi({ ...bitanicaFilter }));
    setClickChoicePopup(false);
  }

  const fetchMore = async () => {
    await wait(1000);
    setFilter((prev) => ({ ...prev, page: prev.page + 1 }));
  };

  const fetchMoreBitanicaHistory = async () => {
    await wait(1000);
    setBitanicaFilter((prev) => ({ ...prev, page: prev.page + 1 }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target) &&
        buttonRef.current && !buttonRef.current.contains(event.target)) {
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const isVisible = usePageVisibility();
  useEffect(() => {
    if (isVisible) {
      getProfile();
    }
  }, [isVisible]);

  const getProfile = () => {
    if (!user?._id) return;
    let bodyParms = {
      _id: user?._id,
    };
    // setIsLoading(true)
    dispatch(
      getUserProfile({
        data: bodyParms,
        callBack: (err, res) => {
          // setIsLoading(false)
          if (err) return;
          if (res.status === "success") {
            setGameEnergyLeft(res?.data?.energyBalance);
            setBtncBalance(res?.data?.btncBalance);
          }
        },
      })
    );
  };

  const {
    screenSize: { dynamicHeight },
  } = useWindow();
  const elementRef = useRef(null);

  useEffect(() => {
    const calculateScrollStop = () => {
      if (elementRef.current) {
        const elementHeight = elementRef.current.offsetHeight;
        setScrollStopOn(dynamicHeight - 128 > elementHeight);
        calculateScrollStop();
        window.addEventListener("resize", calculateScrollStop);
        return () => window.removeEventListener("resize", calculateScrollStop);
      }
    };
  }, [dynamicHeight, unclaimedCoinsList, bitanicaHistory]);

  const onClickChoice = (data) => {
    try {
      if (!isBitanicaLinked && !user.isWalletConnected) return;
      if (unclaimLoading) return;
      setSelectedItem(data);
      setClickChoicePopup(true);
    }
    catch (error) {
      console.log("error on click claim", error);
    }
  }
  console.log("scroll stop on ===>", scrollStopOn, totalUnclaimedCoins, bitanicaHistoryCount);
  console.log("telgram wallet & bitanica wallet", user.isWalletConnected, isBitanicaLinked, !isBitanicaLinked && !user.isWalletConnected);
  return (
    <div
      className={`${scrollStopOn && (totalUnclaimedCoins <= 10 || bitanicaHistoryCount <= 10) ? "no-minimize" : ""
        }`}
    // className="no-minimize"
    >
      {linkAccount && (
        <LinkAccountPop
          linkAccount={linkAccount}
          setLinkAccount={() => {
            setLinkAccount(false);
            setTimeout(() => {
              setRowData(null);
            }, 100);
          }}
          rowData={rowData}
        />
      )}

      {(loadingBitanicLink || unclaimLoading) && <LoaderCstm />}

      {!unclaimLoading && !loadingBitanicLink && !(unclaimedCoinsList?.length > 0) && (
        <div className="d-flex justify-content-center align-items-center">
          <span className="text-white">No data found!</span>
        </div>
      )}

      <Tab.Container id="wallet-tabs" defaultActiveKey="Available">
        <Nav variant="pills" className="commonTabs">
          <Nav.Item className="w-50">
            <Nav.Link className="d-flex align-items-center justify-content-center" eventKey="Available">Available</Nav.Link>
          </Nav.Item>
          <Nav.Item className="w-50">
            <Nav.Link className="d-flex align-items-center justify-content-center" eventKey="History">History</Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="Available">
            <InfiniteScroll
              dataLength={unclaimedCoinsList?.length}
              next={fetchMore}
              hasMore={unclaimedCoinsList?.length < totalUnclaimedCoins}
              scrollThreshold={0}
              scrollableTarget="cryptoWalletWrp"
              initialScrollY={true}
              loader={
                unclaimLoading
              }
            >
              <ul
                ref={elementRef}
                id="cryptoWalletWrp"
                style={{
                  maxHeight: isBitanicaLinked
                    ? "calc(100vh - 360px)"
                    : "calc(100vh - 460px)",
                  height: "auto",
                  overflowY: "scroll",
                }}
                className="list-unstyled ps-0 mb-0 allow-scroll"
              >
                {[...unclaimedCoinsList]
                  .sort((a, b) => (a.type === "expiry" ? -1 : 1))
                  .map((item) => (
                    <li className="py-1" key={item?._id}>
                      <div
                        className={`${styles.cardCstm} ${item?.status !== "claimed" &&
                          item?.status !== "processing" &&
                          item?.status !== "rejected"
                          ? styles.active
                          : ""
                          } position-relative px-3 py-2 cardCstm `}
                      >
                        <div className="d-flex align-items-center gap-10 justify-content-between">
                          <span
                            className={`${styles.wave} ${item?.type === "expiry" && "w-100 h-100"
                              } wave position-absolute`}
                            style={{ bottom: 0, left: 0, zIndex: 0 }}
                          >
                            {item?.type === "expiry" ? starBg : wave}
                          </span>
                          <div
                            className={`${styles.left} left d-flex align-items-center gap-10`}
                          >
                            <span className="flex-shrink-0">
                              <img
                                src={item?.coinIcon}
                                alt=""
                                style={{ width: 40, height: 40 }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = diamond1;
                                }}
                              />
                            </span>
                            <div className="content">
                              <h6 className="m-0 text-white">{item?.coinSymbol}</h6>
                            </div>
                          </div>

                          <div className="center">
                            <p className="m-0 fw-bold text-white" style={{ marginLeft: "-30px !important" }}>
                              {item?.leftAmount &&
                                Number(item?.leftAmount) // Ensure it's a number
                                  .toFixed(4) // Limit to 6 decimal places
                                  .replace(/\.?0+$/, "") // Remove trailing zeros
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                            </p>
                          </div>
                          <div className="right">
                            <Button
                              onClick={(e) => {
                                e?.preventDefault();
                                if (!user?._id) return;
                                if (
                                  item?.status === "claimed" ||
                                  item?.status === "rejected" ||
                                  item?.status === "processing"
                                )
                                  return;
                                if (!isBitanicaLinked && !user.isWalletConnected) {
                                  showToast("Connect your Bitanica or Telegram wallet to claim.", "error");
                                  return;
                                }
                                else {
                                  onClickChoice(item)
                                }
                              }}
                              className={`${styles.btn} ${item?.status === "claimed"
                                ? styles.claimed
                                : item?.status === "processing"
                                  ? styles.pending
                                  : item?.status === "rejected"
                                    ? styles.rejected
                                    : ""
                                } `}
                              style={{
                                lineHeight: 1, fontSize: "12px", maxWidth: "75px",
                                height: "32px"
                              }}
                            >
                              {unclaimLoading && item?._id === rowData?._id ? (
                                <Spinner className="mx-1" size="sm" />
                              ) : (
                                <div className="d-flex align-items-center justify-content-center">
                                  {item?.status === "claimed"
                                    ? "Claimed"
                                    : item?.status === "processing"
                                      ? "Pending"
                                      : item?.status === "rejected"
                                        ? "Rejected"
                                        : "Claim"}
                                </div>
                              )}
                            </Button>
                          </div>
                        </div>
                        {item?.type === "expiry" && (
                          <CountdownTimer expiryTime={item?.expiryTime} />
                        )}
                      </div>
                    </li>
                  ))}
              </ul>
            </InfiniteScroll>
          </Tab.Pane>
          <Tab.Pane eventKey="History">
            <InfiniteScroll
              dataLength={bitanicaHistory?.length}
              next={fetchMoreBitanicaHistory}
              hasMore={bitanicaHistory?.length < bitanicaHistoryCount}
              scrollThreshold={0}
              scrollableTarget="cryptoWalletWrapBitanica"
              initialScrollY={true}
              loader={
                bitanicaHistoryLoading
              }
            >
              <ul
                ref={elementRef}
                id="cryptoWalletWrapBitanica"
                style={{
                  maxHeight: isBitanicaLinked
                    ? "calc(100vh - 360px)"
                    : "calc(100vh - 460px)",
                  height: "auto",
                  overflowY: "scroll",
                }}
                className="list-unstyled ps-0 mb-0 allow-scroll"
              >
                {[...bitanicaHistory]
                  .map((item) => (
                    <li className="py-1" key={item?._id}>
                      {item?.withdrawalPlatform === "bitanica" ? (
                        <div
                          className={`${styles.cardCstm} 
                              ${item?.status !== "rejected" ? styles.active : ""} 
                              position-relative px-3 py-2 cardCstm`} >
                          <div className="d-flex align-items-center gap-10 justify-content-between">
                            <span
                              className={`${styles.wave} wave position-absolute`}
                              style={{ bottom: 0, left: 0, zIndex: 0 }}
                            >
                              <img src={wavesvg} alt="" className="img-fluid w-100" />
                            </span>
                            <div
                              className={`${styles.left} left d-flex align-items-center gap-10`}
                            >
                              <span className="flex-shrink-0">
                                <img
                                  src={item?.coinIcon}
                                  alt=""
                                  style={{ width: 40, height: 40 }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = diamond1;
                                  }}
                                />
                              </span>
                              <div className="content">
                                <h6 className="m-0 text-white">{item?.coinSymbol}</h6>
                                <p className="m-0 fw-bold">
                                  {item?.amount &&
                                    Number(item?.amount) // Ensure it's a number
                                      .toFixed(4) // Limit to 6 decimal places
                                      .replace(/\.?0+$/, "") // Remove trailing zeros
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                </p>
                              </div>
                            </div>
                            <div className="center">
                              <p className="m-0 text-white">
                                #Bitanica
                              </p>
                            </div>
                            <div
                              className={`${styles.center} center d-flex align-items-center`}
                              style={{ marginRight: "10px" }}
                            >
                              <span className="icn me-2">{lock}</span>
                              <p className="m-0 fw-bold" style={{ lineHeight: "14px" }}>
                                {item?.date_created_utc &&
                                  moment(item?.date_created_utc).format(
                                    "DD.MM.YY"
                                  )}{" "}
                                <br />
                                {item?.date_created_utc &&
                                  moment(item?.date_created_utc).format("HH:mm:ss")}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={`${styles.cardCstm} ${item?.status !== "failed" ? styles.active : ""}  position-relative px-3 py-2 cardCstm `}
                        >
                          <div className="d-flex align-items-center gap-10 justify-content-between">
                            <span
                              className={`${styles.wave} wave position-absolute`}
                              style={{ bottom: 0, left: 0, zIndex: 0 }}
                            >
                              <img src={wavesvg} alt="" className="img-fluid w-100" />
                            </span>
                            <div
                              className={`${styles.left} left d-flex align-items-center gap-10`}
                            >
                              <span className="flex-shrink-0">
                                <img
                                  src={item?.coinIcon}
                                  alt=""
                                  style={{ width: 40, height: 40 }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = diamond1;
                                  }}
                                />
                              </span>
                              <div className="content">
                                <h6 className="m-0 text-white">{item?.coinSymbol}</h6>
                                <p className="m-0 fw-bold">
                                  {item?.amount &&
                                    Number(item?.amount) // Ensure it's a number
                                      .toFixed(4) // Limit to 6 decimal places
                                      .replace(/\.?0+$/, "") // Remove trailing zeros
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                </p>
                              </div>
                            </div>
                            <div className="center">
                              <p className="m-0 text-white">
                                {item?.coinIcon && (
                                  <img
                                    src={item?.toCoinIcon}
                                    alt={item?.toCoinSymbol || "coin icon"}
                                    style={{ width: "20px", height: "20px", marginRight: "2px", marginTop: "-5px" }}
                                  />
                                )}
                                {item?.conversionAmount && Number(item?.conversionAmount)
                                  .toFixed(4) // Limit to 6 decimal places
                                  .replace(/\.?0+$/, "") // Remove trailing zeros
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                              </p>
                              <p className="m-0 text-white">
                                {item?.walletAddress?.slice(0, 4)}...{item?.walletAddress?.slice(-4)}
                              </p>
                            </div>
                            <div
                              className={`${styles.center} center d-flex align-items-center`}
                              style={{ marginRight: "10px" }}
                            >
                              <span className="icn me-2">{lock}</span>
                              <p className="m-0 fw-bold" style={{ lineHeight: "14px" }}>
                                {item?.date_created_utc &&
                                  moment(item?.date_created_utc).format(
                                    "DD.MM.YY"
                                  )}{" "}
                                <br />
                                {item?.date_created_utc &&
                                  moment(item?.date_created_utc).format("HH:mm:ss")}
                              </p>
                            </div>
                          </div>

                        </div>
                      )}
                    </li>
                  ))}
              </ul>
            </InfiniteScroll>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>

      {selectedItem && <ClaimChoicePop
        showChoicePop={clickChoicePopup}
        setShowChoicePop={handlePopupClose}
        item={selectedItem}
        isBitanicaLinked={isBitanicaLinked}
        isWalletConnected={user.isWalletConnected}
      />}
    </div>
  );
};

export default CryptoHistory;
